import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Один из кирпичиков Builder-а, основанный на паттерне Chain-of-Responsibility
 *   для придания возможности создавать динамические фабрики
 */
export var BuilderExtension = /*#__PURE__*/function () {
  function BuilderExtension() {
    _classCallCheck(this, BuilderExtension);
    _defineProperty(this, "next", void 0);
  }
  _createClass(BuilderExtension, [{
    key: "setNext",
    value: function setNext(next) {
      this.next = next;
    }
  }]);
  return BuilderExtension;
}();